export default "__VITE_ASSET__5cd980ab__"